// stores/userStore.js 

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { clearTokens } from '@/network/base/appAxios';

const initialState = {
  user: null,
  auth: null,
  adminDetails: null,
  userRole: null,
};

const actions = set => ({
  // getToken: (authCode) => {
  //   // return getAPIResponse(`/Auth/v1.0/tokens?authcode=${authCode}`)
  // },
  logout: async () => {
    try {
      await logOut();
    } catch (error) {
      console.error('Server logout failed:', error);
    } finally {
      // clear all local storage
      set({ user: null, auth: false, userRole: null });
      // clearTokens();
      // localStorage.removeItem('user-role-storage'); 
      localStorage.clear();
      // Clear any URL parameters (auth codes, state, etc.)
      window.history.replaceState({}, document.title, window.location.pathname);
      // Redirect to clean login page
      window.location.href = '/auth';
    }
  },
  logoutAdmin: async () => {
    try {
      await logOut();
    } catch (error) {
      console.error('Server logout failed:', error);
    } finally {
      set({ adminDetails: null, auth: false });
      // clearTokens();
      localStorage.clear();
      // Clear any URL parameters (auth codes, state, etc.)
      window.history.replaceState({}, document.title, window.location.pathname);
      // Redirect to clean login page
      window.location.href = '/admin/auth';
    }
  },
  setAuth: value => set({ auth: value }),
  setUser: value => set({ user: value }),
  setUserRole: value => set({ userRole: value }),
  setAdminDetails: value => set({ adminDetails: value }),
});

const getters = (_, get) => ({
  isLoggedIn: () => !!get().auth,
  getUserRole: () => get().userRole,
});

// persist the user role in local storage
const persistConfig = {
  name: 'user-role-storage',
  storage: createJSONStorage(() => localStorage),
  partialize: (state) => ({
    userRole: state.userRole,
  }),
};
export const useUserStore = create(persist(
  (set, get) => ({
    ...initialState,
    ...actions(set, get),
    ...getters(set, get),
  }),
  persistConfig
));
